
import {Component, Prop, Vue} from "vue-property-decorator";
import {Nutritions} from "@/models/Recipes/Nutritions";
import {NutrientType} from "@/models/Ingredient/NutrientType";
import {NUTRIENT_UNIT_MAP, round} from "@/utils/Helpers";
import LockIcon from "@/components/icons/LockIcon.vue";
import VTrialMasker from "@/components/vTrialMasker.vue";

@Component({
  components: {VTrialMasker, LockIcon}
})
export default class vSupplementLabelCanada extends Vue {
  @Prop() nutrition!: Nutritions;
  @Prop({ default: true }) showRoundedDv!: boolean;
  @Prop() servingsPerContainer: number;

  NutrientType = NutrientType;

  get servingSize() {
    const d = this.nutrition.displayServingQuantityAndMeasure;
    return d ? `${round(d.item1, 2)} ${d.item2}` : "—";
  }

  getRounded(nutrient: NutrientType) {
    return round(this.nutrition.getRoundedValue(nutrient), 2);
  }

  getDV(nutrient: NutrientType) {
    return round(this.nutrition.getRoundedDailyValue(nutrient), 0);
  }

  getUnit(nutrient: NutrientType) {
    const info = this.nutrition.getNutrientInfo(nutrient);
    if (!info) return "—";
    const unit = NUTRIENT_UNIT_MAP.get(nutrient);
    const value = this.getRounded(nutrient);
    return `${value} ${unit}`;
  }

  getNutrientLabel(nutrient: NutrientType): string {
    return NutrientType[nutrient].replace(/([A-Z])/g, " $1").trim();
  }

  get vitaminsAndMinerals(): NutrientType[] {
    const nutrients: NutrientType[] = [
      NutrientType.VitaminA,
      NutrientType.VitaminC,
      NutrientType.VitaminD,
      NutrientType.VitaminE,
      NutrientType.VitaminK,
      NutrientType.Thiamine,
      NutrientType.Riboflavin,
      NutrientType.Niacin,
      NutrientType.VitaminB6,
      NutrientType.Folate,
      NutrientType.VitaminB12,
      NutrientType.Biotin,
      NutrientType.PantothenicAcid,
      NutrientType.Phosphorus,
      NutrientType.Iodine,
      NutrientType.Magnesium,
      NutrientType.Zinc,
      NutrientType.Selenium,
      NutrientType.Copper,
      NutrientType.Manganese,
      NutrientType.Chromium,
      NutrientType.Molybdenum,
      NutrientType.Chloride,
      NutrientType.Choline,
      NutrientType.Caffeine,
      NutrientType.Taurine,
    ];

    return nutrients.filter((nutrient) => {
      const value = this.nutrition.getRoundedValue(nutrient);
      return value !== 0 && value !== null && value !== undefined;
    });
  }
}
